// Simple phone auth token utilities and auth API wrappers
import axios from 'axios';

// Resolve API origin from the public base used in landListingsAPI
export const getApiOrigin = () => {
  const base = process.env.REACT_APP_API_BASE_URL ||
    (typeof window !== 'undefined' && window.location.hostname === 'localhost'
      ? 'http://localhost:3001/api/public'
      : 'https://landlayoutapi.vercel.app/api/public');
  return base.replace(/\/api\/public$/, '');
};

const TOKEN_KEY = 'phone_auth_token';
const PHONE_KEY = 'phone_number';

export const getPhoneAuthToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
};

export const setPhoneAuthToken = (token) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {}
};

export const clearPhoneAuthToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
};

export const setUserPhone = (phone) => {
  try {
    localStorage.setItem(PHONE_KEY, phone);
  } catch {}
};

export const getUserPhone = () => {
  try {
    return localStorage.getItem(PHONE_KEY) || '';
  } catch {
    return '';
  }
};

export const getUserIdFromToken = () => {
  try {
    const token = getPhoneAuthToken();
    if (!token) return null;
    
    // Token format: base64-encoded JSON with _phone_auth suffix
    // Remove the suffix and decode
    const tokenWithoutSuffix = token.replace(/_phone_auth$/, '');
    const decoded = JSON.parse(atob(tokenWithoutSuffix));
    return decoded.userId || null;
  } catch {
    return null;
  }
};

// Minimal auth client for phone register/login
const authClient = axios.create({
  baseURL: getApiOrigin(),
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

export const phoneRegister = async (phone, name = '') => {
  const res = await authClient.post('/api/auth/phone-register', { phone, name });
  return res.data;
};

export const passwordRegister = async (phone, name, password) => {
  const res = await authClient.post('/api/auth/password-register', { phone, name, password });
  return res.data;
};

export const phoneLogin = async (phone) => {
  const res = await authClient.post('/api/auth/phone-login', { phone });
  return res.data;
};

export const passwordLogin = async (phone, password) => {
  const res = await authClient.post('/api/auth/password-login', { phone, password });
  return res.data;
};

export const ensurePhoneAuth = async (phone, name = '') => {
  // Try register, fallback to login if already exists
  try {
    const reg = await phoneRegister(phone, name);
    return reg;
  } catch (e) {
    // If register fails (e.g., already exists), attempt login
    const log = await phoneLogin(phone);
    return log;
  }
};

export default {
  getPhoneAuthToken,
  setPhoneAuthToken,
  clearPhoneAuthToken,
  getUserIdFromToken,
  phoneRegister,
  passwordRegister,
  phoneLogin,
  passwordLogin,
  ensurePhoneAuth,
  getApiOrigin,
};
